<form [formGroup]="generalGardenInquiryForm" InvalidControlScroll>

  <div class="row">
    <div class="col-md-6">
      <div class="jwc_form_group">
        <div class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select">{{inquiryType}}</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="inquiryTypeValue.emit(item)" *ngFor="let item of inquiryData?.inquiryType">{{item}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="jwc_form_group">
        <div class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select">{{ brand }}</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="brandValue.emit(item.value)" *ngFor="let item of generalGardenData?.brand">{{item.label}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="jwc_form_title">
        A few more details and you’ll be all set
      </div>
    </div>
    <div class="col-md-6">
      <div class="jwc_form_group">
        <label>Name</label><span class="text-danger">*</span>
        <input type="text" name="" value="" placeholder="Name" class="form-control jwc_input" id=""
          formControlName="nameInput" appAllowedInput [alphabetsOnly]="true" aria-describedby="namegardenError">
      </div>
      <div aria-live="assertive" id="namegardenError"
        *ngIf="(generalGardenFormControls.nameInput.touched || submitted) && generalGardenFormControls.nameInput.errors">
        <div *ngIf="generalGardenFormControls.nameInput.errors.required" class="error-text">{{errorText}}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="jwc_form_group">
        <label>Company</label>
        <input type="text" name="" value="Organiser Company" placeholder="Company Name" class="form-control jwc_input"
          id="" formControlName="companyInput">
      </div>
    </div>
    <div class="col-md-6">
      <div class="jwc_form_group">
        <label>Email</label><span class="text-danger">*</span>
        <input type="email" name="" value="Juraij@gmail.com" placeholder="Email" class="form-control jwc_input" id=""
          formControlName="emailInput" aria-labelledby="emailgarderError">
      </div>
      <div aria-live="assertive" id="emailgarderError"
        *ngIf="(generalGardenFormControls.emailInput.touched || submitted) && generalGardenFormControls.emailInput.errors">
        <div *ngIf="generalGardenFormControls.emailInput.errors.required" class="error-text">{{errorText}}</div>
        <div *ngIf="generalGardenFormControls.emailInput.errors.pattern" class="error-text">Email must be a valid email
          address
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <label>Phone</label><span class="text-danger">*</span>
      <div class="jwc_form_group jwc_form_phn">
        <div class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select">+91</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="setDropdownValue('countryCode', item)" *ngFor="let item of generalGardenArrData?.countryCode">{{item}}</li>
            </ul>
          </div>
        </div>
        <input type="text" name="" value="" placeholder="Phone Number" class="form-control jwc_input" id=""
          formControlName="phoneNoInput" maxlength="10" appAllowedInput [numbersOnly]="true" aria-describedby="phonegarderError">
      </div>
      <div aria-live="assertive" id="phonegarderError" class="error-text"
        *ngIf="(generalGardenFormControls.phoneNoInput.touched || submitted) && generalGardenFormControls.phoneNoInput.errors">
        Enter 10 digit Mobile Number</div>
    </div>
    <div class="col-md-12">
      <div class="jwc_form_group">
        <label>Message</label><span class="text-danger">*</span>
        <textarea name="" id="" class="form-control jwc_textarea" placeholder="Message" cols="30" rows="10"
          formControlName="messageInput" aria-describedby="messagegarderError"></textarea>
      </div>
      <div aria-live="assertive" id="messagegarderError" *ngIf="(generalGardenFormControls.messageInput.touched || submitted) && generalGardenFormControls.messageInput.errors">
        <div *ngIf="generalGardenFormControls.messageInput.errors.required" class="error-text">{{errorText}}</div>
      </div>
    </div>

    <!-- <div class="col-md-12">
      <div class="jwc_form_title">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
        invidunt
      </div>
      <div class="row">
        <div class="col-lg">
          <div class="jwc_form_group jwc_date_time">
            <input type="text" name="" value="From Date" class="form-control jwc_input_date" id=""
              data-toggle="datepicker">
            <input type="text" class="form-control jwc_input_time timepicker" value="2:30 AM">
          </div>
        </div>
        <div class="col-lg">
          <div class="jwc_form_group jwc_date_time">
            <input type="text" name="" value="End Date" class="form-control jwc_input_date" id=""
              data-toggle="datepicker">
            <input type="text" class="form-control jwc_input_time timepicker" value="2:30 AM">
          </div>
        </div>
      </div>
    </div> -->

    <div class="col-md-6">
      <div class="jwc_form_group">
        <div class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select">{{typeOfEvent ? typeOfEvent : 'Type of Event'}}</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="setDropdownValue('typeOfEvent', item)" *ngFor="let item of generalGardenArrData?.typeOfEvents">{{item}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="row">
    <div class="col-lg-4 col-md-6">
      <div class="jwc_form_group">
        <label>How many guests are you expecting?</label>
        <input type="text" name="" value="" placeholder="Number of people" class="form-control jwc_input" id="" formControlName="numberOfPeopleInput" appAllowedInput [numbersOnly]="true">
      </div>
    </div>
    <div class="col-md-12">
      <div class="custom-control custom-checkbox checkbox jwc_form_group">
        <input type="checkbox" class="custom-control-input" id="dontmiss" name="dontmiss" formControlName="firstConsent">
        <label class="custom-control-label consent" for="dontmiss">
          <span class="text-danger">* </span>
          <span class="ml-1">
            I have read, understood, and accept the Jio World Centre <a href="{{'/legal?tab=privacy'}}" 
            (click)="_sharedService.checkCTALink($event, staticUrlForImgNew + '/legal?tab=privacy', '_blank', 'External')">
            Privacy Policy</a> and consent to sharing of my personal data with Jio World Centre for the purpose of enquiry.
          </span>
        </label>
      </div>
      <div class="error-text" *ngIf="submitted && generalGardenFormControls.firstConsent.errors">{{errorText}}</div>
    </div>

    <div class="col-md-12">
      <div class="custom-control custom-checkbox checkbox jwc_form_group">
        <input class="custom-control-input" type="checkbox" id="gridCheckForSecondConsent" formControlName="secondConsent">
        <label class="custom-control-label" for="gridCheckForSecondConsent">
            I agree to receive communications regarding personalized services and other relevant 
            information about Jio World Centre and its affiliated services.
        </label>
      </div>
    </div>
    <!-- Recaptha code -->
    <div class="col-md-12 captcha">
      <re-captcha (resolved)="gardenCaptchaRes($event)" [siteKey]="captchaSiteKey"
          (error)="gardenCaptchaRes($event, true)" errorMode="handled"></re-captcha>
      <div class="error-text" style="margin-top:5px" *ngIf="submitted && !isCaptchaSelected">{{errorText}}</div>
    </div>
  </div>

  <div class="jwc_form_group--btn">
    <button type = "submit" [ngClass]="{'disabled':disableBtn}" [disabled]="disableBtn" class="cta-prim color-gold" (click)="generalGardenSubmit(generalGardenInquiryForm)"><span
        class="cta-prim-txt">SUBMIT</span></button>
  </div>
  <div class="error-text" style="margin-top:5px" *ngIf="apiErrorMsg">{{apiErrorMsg}}</div>
</form>